"use client";

import { Button } from "@mui/material";
import { useFormStatus } from "react-dom";

interface SubmitButtonProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: "small" | "medium" | "large";
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
  variant?: "text" | "outlined" | "contained";
  sx?: any;
}

export function SubmitButton({
  children,
  fullWidth = true,
  size = "large",
  color = "primary",
  variant = "contained",
  sx,
}: SubmitButtonProps) {
  const { pending } = useFormStatus();

  return (
    <Button
      type="submit"
      disabled={pending}
      fullWidth={fullWidth}
      size={size}
      color={color}
      variant={variant}
      sx={sx}
    >
      {children}
    </Button>
  );
}
